var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSponsors(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "59px",
    height: "45px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.463
    },
    fill: "#8f95a7",
    d: "M 14.5,3.5 C 17.978,1.66977 20.3114,2.66977 21.5,6.5C 19.7867,4.14963 17.4534,3.14963 14.5,3.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.659
    },
    fill: "#a2a7b5",
    d: "M 49.5,5.5 C 42.5009,1.50862 38.8342,3.50862 38.5,11.5C 36.8566,4.31312 39.8566,1.47979 47.5,3C 48.756,3.41691 49.4226,4.25025 49.5,5.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#373f60",
    d: "M 14.5,3.5 C 17.4534,3.14963 19.7867,4.14963 21.5,6.5C 22.7416,8.38879 22.7416,10.3888 21.5,12.5C 18.3893,14.652 15.056,14.9853 11.5,13.5C 8.89566,9.31753 9.89566,5.9842 14.5,3.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#31395b",
    d: "M 49.5,5.5 C 49.5,7.83333 49.5,10.1667 49.5,12.5C 49.5,13.1667 49.1667,13.5 48.5,13.5C 45.5422,14.5411 42.5422,14.5411 39.5,13.5C 38.6618,13.1583 38.3284,12.4916 38.5,11.5C 38.8342,3.50862 42.5009,1.50862 49.5,5.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.573
    },
    fill: "#a0a4b3",
    d: "M 49.5,5.5 C 52.1667,7.83333 52.1667,10.1667 49.5,12.5C 49.5,10.1667 49.5,7.83333 49.5,5.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.906
    },
    fill: "#7e8498",
    d: "M 33.5,13.5 C 29.963,13.3107 26.6297,13.9774 23.5,15.5C 23.5774,14.2502 24.244,13.4169 25.5,13C 28.367,12.1993 31.0336,12.3659 33.5,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.106
    },
    fill: "#c4c7cf",
    d: "M 33.5,13.5 C 35.5,13.5 36.5,14.5 36.5,16.5C 35.1667,15.8333 34.1667,14.8333 33.5,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.404
    },
    fill: "#b0b4c0",
    d: "M 21.5,12.5 C 20.488,14.876 18.6546,15.876 16,15.5C 13.9919,15.6932 12.4919,15.0265 11.5,13.5C 15.056,14.9853 18.3893,14.652 21.5,12.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#31395b",
    d: "M 33.5,13.5 C 34.1667,14.8333 35.1667,15.8333 36.5,16.5C 36.5,18.8333 36.5,21.1667 36.5,23.5C 36.5,23.8333 36.5,24.1667 36.5,24.5C 35.5,25.1667 34.5,25.8333 33.5,26.5C 31.1432,26.6633 28.8098,26.4966 26.5,26C 25.5291,24.5187 24.1958,23.6854 22.5,23.5C 22.4013,20.7628 22.7347,18.0961 23.5,15.5C 26.6297,13.9774 29.963,13.3107 33.5,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.404
    },
    fill: "#979cac",
    d: "M 39.5,13.5 C 42.5422,14.5411 45.5422,14.5411 48.5,13.5C 47.6879,14.9931 46.3545,15.6598 44.5,15.5C 42.4434,15.5643 40.7767,14.8976 39.5,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2a3355",
    d: "M 8.5,17.5 C 10.1667,17.5 11.8333,17.5 13.5,17.5C 15.5,17.5 17.5,17.5 19.5,17.5C 19.1984,20.0593 19.5318,22.3926 20.5,24.5C 16.2853,26.4364 11.6186,27.1031 6.5,26.5C 7.16667,23.5 7.83333,20.5 8.5,17.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3a4162",
    d: "M 50.5,17.5 C 50.8726,20.5739 51.5392,23.5739 52.5,26.5C 47.5,26.5 42.5,26.5 37.5,26.5C 38.2341,25.2921 38.5674,23.9587 38.5,22.5C 38.2606,20.5328 38.5939,18.6995 39.5,17C 43.2027,16.4213 46.8694,16.588 50.5,17.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.424
    },
    fill: "#b7bac5",
    d: "M 36.5,16.5 C 37.1667,18.5 37.8333,20.5 38.5,22.5C 38.5674,23.9587 38.2341,25.2921 37.5,26.5C 37.5,26.8333 37.5,27.1667 37.5,27.5C 36.7611,27.631 36.0944,27.4643 35.5,27C 36.2524,26.3292 36.5858,25.4959 36.5,24.5C 37.8333,24.1667 37.8333,23.8333 36.5,23.5C 36.5,21.1667 36.5,18.8333 36.5,16.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#c3c6d0",
    d: "M 23.5,15.5 C 22.7347,18.0961 22.4013,20.7628 22.5,23.5C 21.8333,23.5 21.5,23.8333 21.5,24.5C 21.1667,24.5 20.8333,24.5 20.5,24.5C 19.5318,22.3926 19.1984,20.0593 19.5,17.5C 17.5,17.5 15.5,17.5 13.5,17.5C 15.6074,16.5318 17.9407,16.1984 20.5,16.5C 20.6737,24.4728 21.1737,24.4728 22,16.5C 22.3826,15.944 22.8826,15.6107 23.5,15.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.784
    },
    fill: "#8d93a5",
    d: "M 22.5,24.5 C 22.5,24.1667 22.5,23.8333 22.5,23.5C 24.1958,23.6854 25.5291,24.5187 26.5,26C 28.8098,26.4966 31.1432,26.6633 33.5,26.5C 29.4538,28.2003 25.7871,27.5336 22.5,24.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.689
    },
    fill: "#6f768e",
    d: "M 8.5,17.5 C 7.83333,20.5 7.16667,23.5 6.5,26.5C 11.6186,27.1031 16.2853,26.4364 20.5,24.5C 20.8333,24.5 21.1667,24.5 21.5,24.5C 21.8333,24.5 22.1667,24.5 22.5,24.5C 22.5,25.5 22.5,26.5 22.5,27.5C 16.5,27.5 10.5,27.5 4.5,27.5C 4.88161,23.6684 6.21495,20.335 8.5,17.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.688
    },
    fill: "#697189",
    d: "M 50.5,17.5 C 52.1981,20.2314 53.5315,23.2314 54.5,26.5C 48.8722,27.4954 43.2055,27.8288 37.5,27.5C 37.5,27.1667 37.5,26.8333 37.5,26.5C 42.5,26.5 47.5,26.5 52.5,26.5C 51.5392,23.5739 50.8726,20.5739 50.5,17.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.689
    },
    fill: "#737b91",
    d: "M 42.5,35.5 C 41.0687,34.2196 40.4021,32.5529 40.5,30.5C 32.747,30.201 25.0804,30.5343 17.5,31.5C 21.107,30.176 25.107,29.5093 29.5,29.5C 33.5,29.8333 37.5,30.1667 41.5,30.5C 42.3094,32.0709 42.6427,33.7376 42.5,35.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#2a3355",
    d: "M 42.5,35.5 C 43.4345,36.5676 43.7678,37.901 43.5,39.5C 34.5599,41.4722 25.2266,42.1389 15.5,41.5C 15.5,40.5 15.5,39.5 15.5,38.5C 17.0739,36.8984 17.7406,34.8984 17.5,32.5C 17.5,32.1667 17.5,31.8333 17.5,31.5C 25.0804,30.5343 32.747,30.201 40.5,30.5C 40.4021,32.5529 41.0687,34.2196 42.5,35.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.831
    },
    fill: "#8f94a6",
    d: "M 17.5,32.5 C 17.7406,34.8984 17.0739,36.8984 15.5,38.5C 15.595,36.2143 16.2616,34.2143 17.5,32.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.501
    },
    fill: "#949aab",
    d: "M 15.5,38.5 C 15.5,39.5 15.5,40.5 15.5,41.5C 25.2266,42.1389 34.5599,41.4722 43.5,39.5C 44.404,40.209 44.7373,41.209 44.5,42.5C 34.5,42.5 24.5,42.5 14.5,42.5C 14.2322,40.901 14.5655,39.5676 15.5,38.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsors);
export default __webpack_public_path__ + "static/media/sponsors.9046ed3d632d6823002cfeea40d8cba4.svg";
export { ForwardRef as ReactComponent };